import * as React from 'react';

import { ComplimentsContainer } from 'containers/project-love/features/compliments-container';

const Page: React.FunctionComponent = () => {
  return <ComplimentsContainer />;
};

export default Page;

export { getServerSideProps } from 'lib/get-server-side-props';
